import { makeStyles } from '@material-ui/core';

export const useAccordionStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
}));

export const useAccordionSummaryStyles = makeStyles((theme) => ({
  root: {
    marginBottom: -1,
    padding: '0px',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
      borderBottom: 'none',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}));

export const useAccordionDetailsStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
}));
